import { Box, BoxProps } from '@chakra-ui/react';

import { ContentContainer } from './container';

export function Section(props: BoxProps) {
  const { children, ...rest } = props;

  return (
    <Box
      as='section'
      bgColor='white'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
        xl: '80px 160px',
      }}
      {...rest}
    >
      <ContentContainer>{children}</ContentContainer>
    </Box>
  );
}
